"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.visit = void 0;
function visit(rows, fn) {
    const todo = [...rows];
    while (todo.length > 0) {
        const row = todo.pop();
        fn(row);
        if (row.children) {
            todo.push(...row.children);
        }
    }
}
exports.visit = visit;
